/* Core & libraries */
import React, { useEffect } from "react";
import { useTheme } from "react-jss";
import { useState } from "react";
import { FormattedMessage } from "react-intl";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Image from "react-bootstrap/Image";
import moment from "helpers/moment";
import parse from "html-react-parser";


/* Helpers, constants, custom methods, internal libraries */
import { useAirlineProgramsService } from "../../services/airlineProgramsService.js";
import { useLocaleContext } from "../../contexts/localeContext.js";
import { AS_HOME_LINK } from "../../constants/appConstants.js";

/* Components */
import UCButton from "../buttons/index.js";
import AlaskaImageOne from "../../resources/images/asThDesk.png";
import AlaskaImageTwo from "../../resources/images/asThMobile.svg";
import CarouselImage2 from "../../resources/images/asCarousel.png";
import CarouselImage9 from "../../resources/images/asMobileCaro.png";
import ProgramCarouselModal from "../modals/programCarouselModal/index.js";

/* Styles */
import styles from "./styles.js";


const ASProgramContent = ({ delinkAlaskaAirlines, alaskaAirlinesSupplier, joinAlaskaAirlines }) => {

    const theme = useTheme();
    const classes = styles({ theme });
    const { getStaticContent, staticContent } = useAirlineProgramsService();
    const locale = useLocaleContext();

    const [showProgramCarousel, setShowProgramCarousel] = useState(false);
    const [showFullText, setShowFullText] = useState(false);
    const [currentIndex, setCurrentIndex] = useState(0);

    const formatDate = (dateString) => {
        return moment(dateString).locale(locale).format("D MMM 'YY");
    };
    const handleShow = (index) => {
        setCurrentIndex(index);
        setShowProgramCarousel(true);
    };

    useEffect(() => {
        if (!staticContent || !staticContent?.alaskaAirlines) {
            getStaticContent();
        }
    }, [staticContent]);

    const handleSelect = (selectedIndex) => {
        setCurrentIndex(selectedIndex);
    };

    const images = [
        CarouselImage2, CarouselImage9
    ];

    useEffect(() => {
        if (!staticContent || !staticContent?.alaskaAirlines) {
            getStaticContent();
        }
    }, [staticContent]);

    const toggleText = () => {
        setShowFullText((prev) => !prev);
    };

    const staticContentUnavailable = Object.keys(staticContent).length === 0;
    const asContentUnavailable = staticContent?.alaskaAirlines?.headerText === "" || staticContent?.alaskaAirlines?.text === ""

    const fullText = staticContent?.alaskaAirlines?.text || "";
    const maxVisibleChars = 490;

    let buttonInjected = false;

    const renderFormattedText = (text, truncate = false) => {
        const paragraphs = text.split("\n\n");
        let accumulatedLength = 0;
        let isTruncated = false;

        return paragraphs.map((paragraph, idx) => {
            const parsedParagraph = parse(paragraph);

            if (truncate && !isTruncated) {
                const remainingChars = maxVisibleChars - accumulatedLength;

                if (accumulatedLength + paragraph.length > maxVisibleChars) {
                    const truncatedContent = paragraph.slice(0, remainingChars) + "...";
                    isTruncated = true;

                    const truncatedParsedParagraph = parse(truncatedContent);

                    if (truncatedParsedParagraph.type === "ul") {
                        return (
                            <div key={idx} className={classes.customContentTextParagraph}>
                                {injectButtonInList(truncatedParsedParagraph)}
                            </div>
                        );
                    }

                    return (
                        <div key={idx} className={classes.customContentTextParagraph}>
                            {truncatedParsedParagraph}
                        </div>
                    );
                }
            }

            accumulatedLength += paragraph.length;
            return (
                <div
                    key={idx}
                    className={
                        idx === paragraphs.length - 1
                            ? classes.customContentTextLastParagraph
                            : classes.customContentTextParagraph
                    }
                >
                    {injectButtonInList(parsedParagraph)}
                </div>
            );
        });
    };

    const injectButtonInList = (element) => {
        if (!element || element.type !== "ul" || buttonInjected) {
            return element;
        }

        const children = React.Children.toArray(element.props.children);

        if (children.length > 0) {
            const lastChild = children[children.length - 1];

            if (lastChild.type === "li") {
                const newLastChild = React.cloneElement(lastChild, {
                    children: (
                        <>
                            {lastChild.props.children}
                            <button onClick={toggleText} className={classes.inlineReadMoreButton}>
                                <FormattedMessage id="airlineProgram.alaskaAirlines.program.readMoreDots" />
                                <FormattedMessage id="airlineProgram.alaskaAirlines.program.readMore" />
                            </button>
                        </>
                    ),
                });

                buttonInjected = true;
                return React.cloneElement(element, {
                    children: [...children.slice(0, -1), newLastChild],
                });
            }
        }

        return element;
    };

    // console.log("AS Program Content - alaskaAirlinesSupplier:", alaskaAirlinesSupplier);

    return (
        <div className={classes.asProgramContent}>
            <Col xs={12} className={classes.dividerContainer}>
                <hr className={classes.border} />
            </Col>
            {
                !staticContentUnavailable && !asContentUnavailable && staticContent?.alaskaAirlines ? (
                    <Container className={classes.customContentContainer}>
                        <div>
                            <div className={classes.customContentHeader}>
                                {staticContent?.alaskaAirlines?.headerText}
                            </div>
                            <div className={classes.customContentText}>
                                {showFullText ? (
                                    renderFormattedText(fullText)
                                ) : (
                                    renderFormattedText(fullText.slice(0, maxVisibleChars), true)
                                )}

                                {!buttonInjected && (
                                    <button onClick={toggleText} className={classes.inlineReadMoreButton}>
                                        {showFullText ? (
                                            <FormattedMessage id="airlineProgram.alaskaAirlines.program.readLess" />
                                        ) : (
                                            <FormattedMessage id="airlineProgram.alaskaAirlines.program.readMore" />
                                        )}
                                    </button>
                                )}
                            </div>
                        </div>
                    </Container>
                ) : null
            }
            <Container className={classes.asProgramContainer}>
                <Row className={classes.asProgramRowOne}>
                    <Col className={classes.programWebsiteContainer}>
                        <p className={classes.bookOnText}><FormattedMessage id="airlineProgram.alaskaAirlines.program.bookOn" /></p>
                        <a href={AS_HOME_LINK} target="_blank" className={classes.programWebsiteText}><FormattedMessage id="airlineProgram.alaskaAirlines.program.website" /></a>
                    </Col>
                    {alaskaAirlinesSupplier && alaskaAirlinesSupplier?.userStatus !== "ACTIVE" && (
                        <UCButton
                            onClick={() => joinAlaskaAirlines(alaskaAirlinesSupplier?.providerEntityID)}
                            type="primary"
                            className={classes.connectButton}
                            text={<FormattedMessage id="airlineProgram.alaskaAirlines.program.connectAccountButton" />}
                        />
                    )}
                    {alaskaAirlinesSupplier && alaskaAirlinesSupplier?.userStatus === "ACTIVE" && (
                        <>
                            <Col xs={5}>
                                <p className={classes.accountConnectedText}><FormattedMessage id="airlineProgram.alaskaAirlines.program.accountConnected" /></p>
                                <Row xs={12} className={classes.accountDetailsContainer}>
                                    <span className={classes.programAccountNumberText}>{alaskaAirlinesSupplier?.membershipNumber}</span><span className={classes.programAccountConnectedDate}>{formatDate(alaskaAirlinesSupplier?.dateLinked)}</span>
                                </Row>
                            </Col>
                            <Col className={classes.connectButtonContainer} xs={3}>
                                <UCButton
                                    onClick={() => delinkAlaskaAirlines(alaskaAirlinesSupplier?.providerEntityID)}
                                    type="link"
                                    className={classes.delinkButton}
                                    text={<FormattedMessage id="airlineProgram.alaskaAirlines.program.disconnectAccountButton" />}
                                    loadingStateStyling={classes.loadingState}
                                    spinnerClassName={classes.delinkSpinner}
                                    spinner={{
                                        name: "delinkAlaskaSpinner",
                                        size: 20,
                                    }}
                                />
                            </Col>
                        </>
                    )}
                </Row>
                <Row className={classes.asProgramRowTwo}>
                    <Col xs={6}>
                        <Image
                            onClick={() => handleShow(0)}
                            src={AlaskaImageOne} />
                    </Col>
                    <Col xs={6}>
                        <Image
                            onClick={() => handleShow(1)}
                            src={AlaskaImageTwo} />
                    </Col>
                </Row>
                <Row className={classes.asProgramRowThree}>
                    <Col xs={12}>
                        <Row className={classes.faqContainer}>
                            <p className={classes.faqTitleText}><FormattedMessage id="airlineProgram.alaskaAirlines.program.whatDoINeed" /></p>
                            <p className={classes.faqDescriptionText}>
                                <FormattedMessage id="airlineProgram.alaskaAirlines.program.whatDoINeedDescription" />
                            </p>
                        </Row>
                        <Row className={classes.faqContainer}>
                            <p className={classes.faqTitleText}><FormattedMessage id="airlineProgram.alaskaAirlines.program.howItWorks" /></p>
                            <p className={classes.faqDescriptionText}><FormattedMessage id="airlineProgram.alaskaAirlines.program.howItWorksDescription1" /></p>
                            <p className={classes.faqDescriptionText2}><FormattedMessage id="airlineProgram.alaskaAirlines.program.howItWorksDescription2" /></p>
                        </Row>
                    </Col>
                </Row>
            </Container>
            <ProgramCarouselModal
                show={showProgramCarousel}
                setShow={setShowProgramCarousel}
                providerAirline={"alaska"}
                currentIndex={currentIndex}
                setCurrentIndex={setCurrentIndex}
                handleSelect={handleSelect}
                images={images}
            />
        </div>
    );
};

export default ASProgramContent;